// Tour definitions for CUALAPP onboarding system
// Each tour has an id, steps with target selectors, and descriptions

export const INITIAL_TOUR = {
  id: 'welcome',
  steps: [
    {
      title: 'Bienvenido a CUALAPP',
      description: 'Este es tu espacio. Aqui puedes enviar y recibir dinero, coordinar con otras personas y publicar lo que ofreces. Te mostramos lo esencial en 30 segundos.',
      icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#7c3aed" stroke-width="2"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg>',
      placement: 'bottom'
    },
    {
      title: 'Explora libremente',
      description: 'Puedes moverte y mirar todo sin costo. Aqui a la izquierda encuentras los espacios principales: tu billetera, tus contactos, mensajes y las diferentes areas de la app.',
      icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" stroke-width="2"><path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/><path d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/></svg>',
      placement: 'bottom'
    },
    {
      title: 'Cuando quieras actuar',
      description: 'Enviar dinero, publicar algo o recibir pagos requiere activar tu Celula (un pase muy economico). No te preocupes: cuando lo necesites, te lo explicaremos con calma antes de cualquier cobro.',
      icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#10b981" stroke-width="2"><path d="M9 12l2 2 4-4"/><circle cx="12" cy="12" r="9"/></svg>',
      placement: 'bottom'
    }
  ]
};

// Module-specific tours (triggered on first visit to each module)
export const MODULE_TOURS = {
  domains: {
    id: 'tour_domains',
    steps: [
      {
        title: 'Tus 13 Dominios',
        description: 'Cada dominio representa un area de tu vida. Explora Familia, Salud, Finanzas, Produccion y mas. Haz clic en cualquier dominio para ver y crear acciones.',
        icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#7c3aed" stroke-width="2"><circle cx="12" cy="12" r="9"/></svg>',
        placement: 'bottom'
      },
      {
        title: 'Cual-Acciones',
        description: 'Dentro de cada dominio puedes crear acciones personalizadas. Por ejemplo, en "Produccion" puedes registrar tus productos y servicios.',
        placement: 'bottom'
      }
    ]
  },
  wallet: {
    id: 'tour_wallet',
    steps: [
      {
        title: 'Tu Billetera Digital',
        description: 'Aqui ves tu saldo en CUALcoin (Cc). Puedes recargar saldo y ver el historial de todos tus movimientos.',
        icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" stroke-width="2"><rect x="2" y="6" width="20" height="14" rx="2"/></svg>',
        placement: 'bottom'
      },
      {
        title: 'Recarga y Transfiere',
        description: 'Recarga saldo para operar en el Marketplace, pagar servicios o enviar dinero a otros usuarios.',
        placement: 'bottom'
      }
    ]
  },
  messaging: {
    id: 'tour_messaging',
    steps: [
      {
        title: 'Comunicaciones Unificadas',
        description: 'CUAL Mensaje (CM), CUAL Llamada (CC) y CUAL Video (CV). Tres formas de comunicarte, todo en un solo lugar.',
        icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#7c3aed" stroke-width="2"><path d="M4 6h16v12H4z"/></svg>',
        placement: 'bottom'
      },
      {
        title: 'Responde y Busca',
        description: 'Responde a mensajes especificos, busca en conversaciones y recibe confirmacion de lectura en tiempo real.',
        placement: 'bottom'
      }
    ]
  },
  celula: {
    id: 'tour_celula',
    steps: [
      {
        title: 'Tu Celula',
        description: 'La Celula es tu unidad de gestion dentro de CUALAPP. Representa tu espacio de tiempo y dinero en el ecosistema.',
        icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6366f1" stroke-width="2"><path d="M7 11l5-7 5 7"/><rect x="5" y="11" width="14" height="9" rx="1"/></svg>',
        placement: 'bottom'
      }
    ]
  },
  transactions: {
    id: 'tour_transactions',
    steps: [
      {
        title: 'Historial de Transacciones',
        description: 'Ve todas tus transacciones: envios, recepciones y movimientos. Filtra por fecha, monto o tipo.',
        placement: 'bottom'
      }
    ]
  },
  marketplace: {
    id: 'tour_marketplace',
    steps: [
      {
        title: 'Marketplace P2P',
        description: 'Compra y vende productos o servicios directamente con otros usuarios. Publica tus ofertas y encuentra lo que necesitas.',
        placement: 'bottom'
      },
      {
        title: 'Comercio Seguro',
        description: 'Las transacciones pueden protegerse con Escrow para garantizar la seguridad de ambas partes.',
        placement: 'bottom'
      }
    ]
  },
  escrow: {
    id: 'tour_escrow',
    steps: [
      {
        title: 'Comercio P2P Protegido',
        description: 'El sistema de Escrow retiene los fondos hasta que ambas partes confirmen la transaccion. Seguridad total.',
        placement: 'bottom'
      },
      {
        title: 'Disputas',
        description: 'Si hay un problema, puedes abrir una disputa con evidencia y un mediador resolvera.',
        placement: 'bottom'
      }
    ]
  },
  smart_escrow: {
    id: 'tour_smart_escrow',
    steps: [
      {
        title: 'Smart Contracts',
        description: 'Define condiciones programables para tus acuerdos. Si se cumple la condicion, el pago se libera automaticamente.',
        placement: 'bottom'
      }
    ]
  },
  transport: {
    id: 'tour_transport',
    steps: [
      {
        title: 'Transporte',
        description: 'Solicita viajes con rutas predefinidas, calculo de ETA en tiempo real y tarifas dinamicas.',
        placement: 'bottom'
      },
      {
        title: 'Conductores Calificados',
        description: 'Los conductores se priorizan por su calificacion. Mejor servicio = mas viajes asignados.',
        placement: 'bottom'
      }
    ]
  },
  kyc: {
    id: 'tour_kyc',
    steps: [
      {
        title: 'Verificacion de Identidad',
        description: 'Verifica tu identidad para acceder a funciones avanzadas. Soportamos 8 jurisdicciones: VE, PA, CO, BR, MX, CL, AR, PE.',
        placement: 'bottom'
      }
    ]
  },
  automations: {
    id: 'tour_automations',
    steps: [
      {
        title: 'Automatizaciones',
        description: 'Crea reglas tipo "Si pasa X, entonces haz Y". Automatiza pagos, notificaciones y acciones repetitivas.',
        placement: 'bottom'
      }
    ]
  },
  blockchain: {
    id: 'tour_blockchain',
    steps: [
      {
        title: 'Blockchain Interna',
        description: 'CUALAPP tiene su propia blockchain SHA-256. Explora bloques, mina y verifica transacciones en el explorador.',
        placement: 'bottom'
      }
    ]
  },
  cualjuego: {
    id: 'tour_cualjuego',
    steps: [
      {
        title: 'CUALjuego - RPG Economico',
        description: 'Tu actividad real en CUALAPP se convierte en un juego. Roles, habilidades, logros y un mapa dual del mundo.',
        placement: 'bottom'
      },
      {
        title: 'Crea tus Roles',
        description: 'Ademas de los roles del sistema, puedes crear tus propios roles personalizados.',
        placement: 'bottom'
      }
    ]
  },
  analytics: {
    id: 'tour_analytics',
    steps: [
      {
        title: 'Analytics',
        description: 'Dashboard con graficas y metricas en tiempo real. Visualiza tendencias, volumenes y actividad del sistema.',
        placement: 'bottom'
      }
    ]
  },
  pago_movil: {
    id: 'tour_pago_movil',
    steps: [
      {
        title: 'Pago Movil',
        description: 'Transferencias instantaneas entre usuarios. Rapido, simple y sin intermediarios.',
        placement: 'bottom'
      }
    ]
  },
  cmt: {
    id: 'tour_cmt',
    steps: [
      {
        title: 'CUALmoneytransfer (CMT)',
        description: 'Envia dinero a cualquier usuario CUALAPP del mundo, sin importar en que pais se encuentre. Solo necesitas su nombre, email o telefono.',
        placement: 'bottom'
      },
      {
        title: 'Sin Fronteras',
        description: 'Las transferencias internacionales tienen una comision minima del 0.5%. Las nacionales son gratuitas. Tu dinero llega al instante.',
        placement: 'bottom'
      }
    ]
  }
};
